import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

const BlogRollPagination = ({page,perPage,total,onChange,className,hideLastPage = true}) => {
	const { t } = useTranslation();

	const totalPages = Math.ceil( total / perPage );
	if ( isNaN( totalPages ) || totalPages <= 1 ) {
		return null;
	}
	let pageNumbers = [];
	for ( let p = 1; p <= totalPages; p++ ) {
		pageNumbers.push( p );
	}
	const ellipsis = '...';

	// make a maximum of 6 pages, with ellipsis as placeholders for the others.
	if ( pageNumbers.length > 6 ) {
		switch ( true ) {
			case page <= 3:
				pageNumbers.splice( 4, pageNumbers.length - 5, ellipsis );
				break;
			case page >= totalPages - 3:
				pageNumbers.splice( 1, pageNumbers.length - 5, ellipsis );
				break;
			default:
				pageNumbers.splice( 1, page - 2, '...' );
				pageNumbers.splice( 4, pageNumbers.length - 5, ellipsis );
		}
		/*
		 * Vanilla Elasticsearch cacks if trying to find records past 10,000.  This just makes that harder to get to
		 * becuase it takes the last page number out of the list.
		 */
		if ( hideLastPage && total > 10000 ) {
			pageNumbers.pop();
		}
	}

	const goToPage = ( e, next ) => {
		e.preventDefault();
		e.stopPropagation();
		onChange( isNaN( next ) ? 1 : parseInt( next, 10 ) );
	};

	return <div className={className}>
		<ul className="pagination">

			{ pageNumbers.map( ( pageNumber, i ) => {
				const liClass = classNames({disabled: pageNumber === ellipsis,active: pageNumber === page });
				return <li key={i} className={liClass}><button disabled={pageNumber === ellipsis} onClick={e => goToPage( e, pageNumber )}><span>{pageNumber}</span></button></li>
			})}
			<li className={page <= 1 ? 'disabled prev-btn' : 'prev-btn'}>
				<button
					disabled={page <= 1}
					className="previous"
					onClick={e => goToPage( e, page - 1 )}
					aria-label={t('Previous')}
				>
					<i className="icon icon-chevron-left"></i>
				</button>
			</li>
			<li className={page === totalPages ? 'disabled next-btn' : 'next-btn'}>
				<button
					className="next"
					disabled={page >= totalPages}
					onClick={e => goToPage( e, page + 1)}
					aria-label={t('Next')}
				>
					<i className="icon icon-chevron-right"></i>
				</button>
			</li>
		</ul>
	</div>
};

export default BlogRollPagination;
